<p-dialog
  (visibleChange)="handleVisibleChange($event)"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '32rem', maxWidth: '96vw' }"
  [visible]="visible()"
  [header]="cosmeticName()">
  <app-form-control label="Ilość w pudełku">
    <p-input-number
      [fluid]="true"
      [formControl]="form.controls.amount"
      [min]="1"
      [step]="1"
      [useGrouping]="false"
      inputStyleClass="w-full"
      placeholder="Uzupełnij ilość w pudełku" />
  </app-form-control>

  <app-form-control label="Dostępna ilość do kupienia">
    <p-input-number
      [fluid]="true"
      [formControl]="form.controls.availableQuantity"
      [min]="0"
      [step]="1"
      [useGrouping]="false"
      inputStyleClass="w-full"
      placeholder="Uzupełnij ilość" />
  </app-form-control>

  <div class="mt-4 flex justify-end gap-4">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz" />

    <p-button
      (onClick)="cancelEvent.emit()"
      appPrimengButton
      label="Anuluj"
      severity="secondary" />
  </div>
</p-dialog>
